<template>
  <div>
    <div v-if="!image">
      <v-file-input
        :label="label"
        v-on:change="uploadImg"
        ref="fileIcon"
        accept=".jpg, .png"
        :rules="rules"
        :id="fileInputId"
      ></v-file-input>
    </div>
    <div v-else>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div
            class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted"
          >
            <div class="v-input__slot">
              <div class="v-text-field__slot">
                <label
                  :for="imgControlId"
                  class="v-label v-label--active theme--light"
                  style="left: 0px; right: auto; position: absolute;"
                  >{{ label }}</label
                >
                <img
                  :id="imgControlId"
                  :src="image"
                  style="height:100px;cursor:pointer"
                  @click="$emit('image-data', null)"
                  v-bind="attrs"
                  v-on="on"
                />
              </div>
            </div>
          </div>
        </template>
        <span>Clear</span>
      </v-tooltip>
      <!-- <v-btn color="primary" @click="$emit('image-data', null)">{{
            $t("components.imageuploaderstring.change")
      }}</v-btn>-->
    </div>
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <div style="height: 200px">
          <vueCropper
            ref="cropper"
            :img="imageData"
            :canMove="false"
            :canMoveBox="false"
            :info="true"
            :autoCrop="true"
            outputType="png"
            @realTime="realTime"
          ></vueCropper>
        </div>
        <div
          v-if="previews"
          class="show-preview"
          :style="{
            width: previews.w + 'px',
            height: previews.h + 'px',
            overflow: 'hidden',
            margin: '5px',
          }"
        >
          <div :style="previews.div">
            <img :src="previews.url" :style="previews.img" />
          </div>
        </div>

        <div class="col-auto align-self-center">
          <div ref="icon" style="width: 50px;" class="svg-icon"></div>
        </div>

        <div class="col-auto align-self-center">
          <v-btn
            text
            @click="cancelHandler"
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="saveImageHandler"
            :disabled="!imageData"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { math } from "mathjs/lib/core/function/import";
import { VueCropper } from "vue-cropper";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    VueCropper,
  },
  data: () => ({
    dialog: false,
    uploadUrl: undefined,
    imageData: undefined,
    previews: undefined,
    imgControlId:"img-" +
      Math.random()
        .toString()
        .substr(2, 8),
    fileInputId:"file-" +
      Math.random()
        .toString()
        .substr(2, 8),
  }),
  computed: {
    ...mapGetters("common", { selectedPlan: "plan", settings: "settings" }),
  },
  props: {
    image: String,
    rules: Array,
    label: String,
  },
  mounted() {
    // console.log(this.image);
  },
  // watch: {
  //   image: {
  //     handler() {
  //       console.log("44444444444444");
  //       // this.$forceUpdate();
  //     }
  //   }
  // },
  methods: {
    ...mapActions("downloadCenter", ["uploadFile", "saveImage"]),
    async saveImageHandler() {
      const data = await new Promise((resolve, reject) => {
        this.$refs.cropper.getCropData((data) => {
          // console.log("1111111111111111");
          resolve(data);
        });
      });
      // const res = await this.uploadFile({ base64: data, name: "cropped.png" });
      // let img = { PhysicalFileId: res.Id, PlanId: this.selectedPlan.Id };
      // const image = await this.saveImage(img);
      // img.Id = image;
      // this.$emit("update:image", data);
      // console.log("222222222222222222222");
      this.$emit("image-data", data);
      this.dialog = false;
      // this.$nextTick(() => {
      //   this.$forceUpdate();
      // });
    },
    async uploadImg($event) {
      //console.log($event);

      const reader = new FileReader();
      const file = $event;
      reader.readAsDataURL(file);
      const contents = await new Promise((resolve, reject) => {
        reader.onload = function(event) {
          resolve(reader.result);
        };
      });
      this.imageData = contents; //.split(',')[1];

      this.dialog = true;
    },
    realTime(data) {
      this.previews = data;
    },
    cancelHandler() {
      this.dialog = false;
      this.$refs.fileIcon.value =undefined;
      const fileInput = document.getElementById(this.fileInputId);
      fileInput.previousElementSibling.innerHTML = "";
      this.imageData = undefined;
    }
  },
};
</script>
<style>
.vue-cropper {
  background-repeat: repeat;
}
</style>
